<rid-demo-page [title]="'Morfemenbord'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Morfemenbord | instructiemodus" variant="PRIMARY" routerLink="freeform" />
  <rid-button class="w-full" content="Morfemenbord | opdrachten" variant="PRIMARY" routerLink="assignments" />
</rid-demo-page>
